
import { Component, Vue, Prop, Watch } from "vue-property-decorator"
import { MonthPicker, MonthPickerEvent } from "vue-month-picker"
import { Getter } from "vuex-class"
import moment from "moment"
import { BvEvent } from "bootstrap-vue"

@Component({
	components: {
		"month-picker": MonthPicker
	}
})
export default class MonthPickerControl extends Vue {
	@Prop({ type: [String, Date], default: () => null })
	value!: string | Date | null

	@Prop({ type: String, default: "Select Month" })
	buttonText!: string | null

	@Prop({ type: [String, Date], default: () => null })
	minDate!: string | Date | null

	@Prop({ type: [String, Date], default: () => null })
	maxDate!: string | Date | null

	@Prop({ type: Boolean, default: false })
	isEndMonth!: boolean | null

	@Getter getDarkMode!: boolean;

	modalOpen: boolean = false

	get minDateValue () : Date | null {
		if (this.minDate) {
			return moment(this.minDate).toDate()
		}
		return null
	}

	get maxDateValue () : Date | null {
		if (this.maxDate) {
			if (moment(this.maxDate!).month() !== moment(this.value!).month()) {
				return moment(this.maxDate).toDate()
			}
		}
		return null
	}

	get selectedMonth () : number | null {
		if (this.value) {
			if (!this.isEndMonth) {
				return moment(this.value).month() + 1
			} else {
				return moment(this.value).month() + 1
			}
		}

		return moment().month() + 1
	}

	get selectedMonthLabel () : string | null {
		if (this.value) {
			return moment(this.value).format("MMMM YYYY")
		}
		return null
	}

	get selectedYear () : number | null {
		if (this.value) {
			return moment(this.value).year()
		}
		return moment().year()
	}

	open (event: BvEvent) {
		event.target.blur()

		this.modalOpen = true
	}

	close () {
		this.modalOpen = false
	}

	monthChanged (newMonth: MonthPickerEvent) {
		if (!this.isEndMonth) {
			this.$emit("monthChanged", newMonth.from)
		} else {
			this.$emit("monthChanged", newMonth.to)
		}
		this.close()
	}
}
